(() => {
  let accepted = false;
  const inputs = () => document.querySelectorAll('[data-shark-cart-terms]');
  function update() {
    inputs().forEach((input) => {
      input.checked = accepted;
      input.setCustomValidity(accepted ? '' : input.dataset.error);
      if (accepted) {
        input.removeAttribute('aria-invalid');
        const error = document.getElementById(input.getAttribute('aria-describedby'));
        if (error) error.hidden = true;
      }
    });
    document.querySelectorAll('[data-shark-cart-express]').forEach((element) => {
      element.hidden = !accepted;
      element.inert = !accepted;
    });
  }
  function showError(input) {
    input.setCustomValidity(input.dataset.error);
    input.setAttribute('aria-invalid', 'true');
    const error = document.getElementById(input.getAttribute('aria-describedby'));
    if (error) error.hidden = false;
    input.focus();
  }
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-shark-cart-terms]')) return;
    accepted = event.target.checked;
    update();
  });
  document.addEventListener('invalid', (event) => {
    if (event.target.matches('[data-shark-cart-terms]')) {
      event.preventDefault();
      showError(event.target);
    }
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="checkout"]');
    if (!button || !button.form) return;
    const input = Array.from(inputs()).find((item) => item.form === button.form);
    if (input && !input.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(input);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    const input = Array.from(inputs()).find((item) => item.form === event.target);
    if (input && !input.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(input);
    }
  }, true);
  update();
  new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length || record.removedNodes.length)) update();
  }).observe(document.body, { childList: true, subtree: true });
})();
